import { render } from "./AccessPass.vue?vue&type=template&id=3c20b016"
import script from "./AccessPass.vue?vue&type=script&lang=js"
export * from "./AccessPass.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__